import { ILocation } from 'types/graphqlTypes'
import { ILocationMarketInsightDataFragment } from './graphql/LocationMarketInsightDataFragment'

export type TMarketInsightsLocation = Pick<ILocation, 'city' | 'stateCode'>

export type TMarketInsightRangeKeys = keyof Pick<
  ILocationMarketInsightDataFragment,
  'changeLastSevenDays' | 'changeLastFourteenDays' | 'changeLastThirtyDays'
>

export enum IDayRange {
  LastSevenDays = 7,
  LastFourteenDays = 14,
  LastThirtyDays = 30,
}
